import robotisWorkGaemi from '../../../../assets/images/learn/robotis-work-gaemi.png';
import neubility from '../../../../assets/images/learn/neubility.png';
import { cEl } from '../../../../util';

function OutdoorRobot() {
    const page = cEl('div');
    page.classList.add('learn-page');
    page.innerHTML = `
    <div class="gray-box">
        <h2>실외 배송 로봇</h2>
        <div class="img-container">
            <div class="img-wrapper border-radius">
                <img src="${robotisWorkGaemi}" alt="로보티즈 일개미">
                <span>로보티즈 일개미</span>
            </div>
            <div class="img-wrapper border-radius">
                <img src="${neubility}" alt="뉴빌리티">
                <span>뉴빌리티</span>
            </div>
        </div>
        <div class="description-container">
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">사용처</div>
                <ul class="description-list">
                    <li>건물 간 배송</li>
                </ul>
            </div>
            <div class="description-wrapper" style="flex: 0 0 250px">
            </div>
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">장점</div>
                <ul class="description-list">
                    <li>방수 설계</li>
                </ul>
            </div>
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">주의점</div>
                <ul class="description-list">
                    <li>건물 입구 간 배송만 가능</li>
                    <li>다소 도전적 방식</li>
                    <li>건물 입구에서 수납, 수거해야 함</li>
                </ul>
            </div>
        </div>
    </div>`;

    return page;
}

export default OutdoorRobot;
